module.exports = __webpack_public_path__ + "img/bank_1.14e08f9b.png";